import { render } from "./bind_services.html?vue&type=template&id=5f736130&external"
import script from "./bind_services.js?vue&type=script&lang=js&external"
export * from "./bind_services.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__